export default __webpack_public_path__ + "images/ee38b2eb3c0e1e4a544d0d932ce77717-EE_SlideDeckBOOK1024_3.png";